import { render, staticRenderFns } from "./PropertyForm.vue?vue&type=template&id=9980ae14"
import script from "./PropertyForm.vue?vue&type=script&lang=js"
export * from "./PropertyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports